import 'whatwg-fetch';
import render from './client-render';

render();

if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    module.hot.accept();
  }
}
